export default "__VITE_ASSET__Cz6JxM4c__"